import {
    IAdditionalInfoContainerResult,
    IAdditionalInfoResult
} from './magazine-result';
import { ILcImage } from '../interfaces/magazine-service.interface';

export class AdditionalInfoContainerResult
    implements IAdditionalInfoContainerResult {
    public additionalInfoMainTitle: string;
    additionalInfoLinkText: string;
    additionalInfoLinkUrl: string;
    additionalInfoCategoryName: string;
    additionalInfoList: IAdditionalInfoResult[];
}

export class AdditionalInfoResult implements IAdditionalInfoResult {
    additionalInfoImage: ILcImage;
    additionalInfoTitle: string;
    additionalInfoText: string;
    additionalInfoLinkText: string;
    additionalInfoLinkUrl: string;
}

export class LcImage implements ILcImage {
    url: string;
    alt: string;
}
